/**
 * @generated SignedSource<<3d525515cd13474fee7563ff7351707c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersAppBarVariantArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersArticleSections" | "helpersCheckIsLongReadArticle" | "helpersCheckIsMorningStudioArticle" | "helpersCheckIsPhotoEssayArticle" | "helpersCheckIsPostiesPage" | "helpersStyleArticle" | "helpersStyleSectionContent">;
  readonly " $fragmentType": "helpersAppBarVariantArticle";
};
export type helpersAppBarVariantArticle$key = {
  readonly " $data"?: helpersAppBarVariantArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersAppBarVariantArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersAppBarVariantArticle"
};

(node as any).hash = "afdc20f0d65aa07450a0f2d9a2300c90";

export default node;
